import React from 'react';
import { Composition } from 'remotion';
import type { CalculateMetadataFunction } from 'remotion';
import { Main } from './Main';
import type { ReelsProps } from './types';

export const REELS_COMPOSITION_ID = 'Reels';

export const REELS_DEFAULT_PROPS: ReelsProps = {
  videoSrc: '',
  assetBase: '/video-compositions',
  editData: {
    width: 1080,
    height: 1920,
    fps: 30,
    durationSec: 5,
    camera: { enabled: true, zooms: [1.14, 1.2, 1.12, 1.22, 1.16, 1.1, 1.18], pushIn: 0.04, targetX: 0.5, targetY: 0.4 },
    hook: { enabled: false, endSec: 4, lines: [], style: 'outline', logo: null, sign: null },
    captions: { enabled: false, style: 'karaoke', fontSize: 61, maxWords: 3, safeWidth: 720, paddingBottom: 420 },
    inserts: [],
    behind: [],
    splitInserts: [],
    transitions: [],
    soundtrack: { enabled: false, file: '', volume: 0.0445 },
  },
  captions: [],
  captionCues: [],
  segments: { segments: [] },
  track: null,
};

/** Frames da composição a partir do edit-data (durationSec = duração EXATA do cut.mp4). */
export function reelsMetadata(props: ReelsProps) {
  const d = props.editData;
  const fps = d.fps || 30;
  return {
    fps,
    width: d.width || 1080,
    height: d.height || 1920,
    durationInFrames: Math.max(1, Math.round((d.durationSec || 0) * fps)),
  };
}

const calculateMetadata: CalculateMetadataFunction<Record<string, unknown>> = ({ props }) =>
  reelsMetadata(props as unknown as ReelsProps);

// Tamanho/fps/duração vêm de props.editData (calculateMetadata) — como o Root do edvid lia
// edit-data.json.
export const RemotionRoot: React.FC = () => {
  return (
    <Composition
      id={REELS_COMPOSITION_ID}
      component={Main as unknown as React.FC<Record<string, unknown>>}
      defaultProps={REELS_DEFAULT_PROPS as unknown as Record<string, unknown>}
      calculateMetadata={calculateMetadata}
      durationInFrames={150}
      fps={30}
      width={1080}
      height={1920}
    />
  );
};
